import { axios, toCamelCase, toSnakeCase } from '@utils';

const notificationSettings = [
  { value: 'all', label: 'Receive all emails' },
  { value: 'important', label: 'Receive important emails only' },
];

async function removeAvatar() {
  return axios.delete('/avatar.json');
}

async function getUser() {
  const { data } = await axios.get('/user.json');
  return toCamelCase(data.user);
}

async function updateUser(userObj) {
  const { isImpersonated, ...user } = userObj;
  const response = await axios.put('/user.json', { user: toSnakeCase(user) });
  return toCamelCase(response.data.user);
}

async function updatePassword(password, passwordConfirmation) {
  const response = await axios.put(
    '/users.json',
    {
      user: {
        password,
        password_confirmation: passwordConfirmation,
      },
    },
  ).catch(() => false);

  return response;
}

async function updateName({ firstName, lastName, userType }) {
  const response = await axios.patch(`/api/v1/${userType}_users/update_name`, {
    first_name: firstName,
    last_name: lastName,
  });
  return toCamelCase(response.data);
}

async function getUserNavData(email) {
  const { data } = await axios.get('/api/v1/legup/users/nav', {
    params: {
      email,
    },
  });

  return toCamelCase(data);
}

async function updateUserContact(userObj) {
  const response = await axios.put('/update_contact.json', toSnakeCase(userObj));
  return toCamelCase(response.data.user);
}

export default {
  removeAvatar,
  getUser,
  updateUser,
  updatePassword,
  updateName,
  notificationSettings,
  getUserNavData,
  updateUserContact,
};
